<template>
  <div class="text-center empty-container">
    <svg width="184" height="117" viewBox="0 0 184 117" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M92 117C142.81 117 184 108.057 184 97.0244C184 85.9922 142.81 77.0488 92 77.0488C41.1898 77.0488 0 85.9922 0 97.0244C0 108.057 41.1898 117 92 117Z" fill="#F5F5F5"/>
      <path d="M158.125 39.2662L128.955 6.44342C127.555 4.20615 125.511 2.85352 123.358 2.85352H60.6424C58.489 2.85352 56.4449 4.20615 55.0447 6.44056L25.875 39.2691V65.634H158.125V39.2662Z" stroke="#D9D9D9"/>
      <path d="M119.637 48.3152C119.637 43.7351 122.495 39.954 126.04 39.9512H158.125V91.708C158.125 97.7663 154.33 102.732 149.644 102.732H34.3562C29.67 102.732 25.875 97.7634 25.875 91.708V39.9512H57.96C61.5049 39.9512 64.3626 43.7266 64.3626 48.3067V48.3695C64.3626 52.9496 67.252 56.6479 70.794 56.6479H113.206C116.748 56.6479 119.637 52.9153 119.637 48.3352V48.3152V48.3152Z" fill="#FAFAFA" stroke="#D9D9D9"/>
    </svg>
    <div class="mt-5 font-size-16 text-gray-8">
      {{text}}
    </div>
    <a-button v-if="!isAddDisabled" type="primary" icon="plus" @click="add()" class="mt-3">
      {{textBtn}}
    </a-button>
  </div>
</template>

<script>
export default {
  props: ['text', 'textBtn', 'isAddDisabled'],
  methods: {
    add() {
      this.$emit('add')
    },
  },
}
</script>

<style lang="scss">
.empty-container {
  background-color: #fff;
  padding: 200px 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
}
</style>
